module.exports = __webpack_public_path__ + "c9eae80df8414976f6c30fa66a15d322.svg";